import React from "react";

interface FormStep2Props {
  register: any;
  errors: any;
}

export default function FormStep2({ register, errors }: FormStep2Props) {
  return (
    <section>
      {/* <h2 className="font-semibold text-2xl mb-4">Guest Details</h2> */}

      {/* Guest Profile */}
      <div className="flex flex-wrap mb-6">
        <div className="w-full md:w-4/4 mb-6 md:mb-0">
          <label
            className="text-left block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="student_info"
          >
            Guest Profile
          </label>
          <textarea
            id="student_info"
            className="text-input"
            {...register("student_info", { required: true })}
            placeholder={`Enter the name and age of each guest
All guests must be at least 12 years of age
Minors must be accompanied by an adult`}
            rows={6}
          />
        </div>
      </div>

      {/* Allergies */}
      <div className="flex flex-wrap mb-6">
        <div className="w-full md:w-4/4 mb-6 md:mb-0">
          <label
            className="text-left block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="allergies"
          >
            Allergies and Food Sensitivities
          </label>
          <textarea
            id="allergies"
            className="text-input"
            {...register("allergies", { required: true })}
            placeholder="Let us know about any allergies and food sensitivities for your group"
            rows={4}
          />
        </div>
      </div>

      {/* Error Handling */}
      {errors.student_info && <p className="error-message">{errors.student_info.message}</p>}
    </section>
  );
}